//#region types
import { Amount } from "models/utilTypes/currencyType";
import { TotalSalaryAdditionalChartDataProps } from "models/propTypes/wintSalaryPropTypes";
import { CurrencyEnums } from "models/enums";
//#endregion
//#region components
import { Divider, Grid } from "@mui/material";
import ChartDataDisplay from "./chartDataDisplay";
//#endregion
import { DateHelper } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const TotalSalaryAdditionalChartData: React.FC<TotalSalaryAdditionalChartDataProps> = (props) => {
  const {
    currentPeriod,
    currentPeriodAmount,
    previousPeriod,
    previousPeriodAmount,
    currentPeriodDeviationPercentage,
    previousPeriodDeviationPercentage,
  } = props;

  const currentPeriodTitle = DateHelper.formatMonthRange(currentPeriod.start, currentPeriod.end);
  const previousPeriodTitle = DateHelper.formatMonthRange(previousPeriod.start, previousPeriod.end);

  return (
    <Grid container direction="row" className={cssExports.salaryChartAdditionalData}>
      <Grid item>
        <ChartDataDisplay
          title={currentPeriodTitle}
          value={new Amount(CurrencyEnums.CurrencyCode.SEK, currentPeriodAmount)}
          deviationPercentage={currentPeriodDeviationPercentage}
          showDeviationIndicator
        />
      </Grid>
      <Grid item className={cssExports.titleDivider}>
        <Divider orientation="vertical" className={cssExports.verticalDividerGrey} />
      </Grid>
      <Grid item sx={{ paddingLeft: "16px" }}>
        <ChartDataDisplay
          title={previousPeriodTitle}
          value={new Amount(CurrencyEnums.CurrencyCode.SEK, previousPeriodAmount)}
          deviationPercentage={previousPeriodDeviationPercentage}
          showDeviationIndicator
        />
      </Grid>
    </Grid>
  );
};

export default TotalSalaryAdditionalChartData;
